const Footer = () => {
  return (
    <footer className='footer'>
      <p className='attribution'>
        Challenge by{' '}
        <a
          href='https://www.frontendmentor.io/challenges/character-counter-znSgeWs_i6'
          target='_blank'
          rel='noreferrer'>
          Frontend Mentor
        </a>
        . Coded by{' '}
        <a
          href='https://www.claytondewey.com/'
          target='_blank'
          rel='noreferrer'>
          Clayton Dewey
        </a>
        .
      </p>
    </footer>
  );
};
export default Footer;
